export default __webpack_public_path__ + "static/media/andina.b4734efa.png";